import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Cl Project",
  "Cl Quotation",
  "Estimate Date",
  "T.AMT (inc) gst",
  "Business name",
  "Status",
  "Actions",
];
const EstimateTable = ({ data, currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const returnClassname = (status) => {
    if (status === "completed") {
      return "badge bg-success  text-white";
    } else if (status === "draft") {
      return "badge bg-danger  text-white";
    }
  };
  const goToView = (id) => {
    id = getId(id);
    navigate(`/estimate/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const lineItems = item?.lineItems;
            const subtotalPrice = lineItems.reduce(
              (acc, item) => acc + item.itemPrice * item.itemQuantity,
              0
            );
            const totalGst = lineItems.reduce(
              (acc, item) =>
                acc + (item.totalWithGst - item.itemPrice * item.itemQuantity),
              0
            );
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.invoiceNumber}>
                <td>{Index}</td>
                {/* <td>{getId(item?.invoiceNumber)}</td> */}
                <td>{item?.clproject || "N/A"}</td>
                <td>{item?.clquotation || "N/A"}</td>
                <td>{item?.invoiceDate || "N/A"}</td>
                {/* <td>
                  ₹
                  {+subtotalPrice + +totalGst ||
                    item?.totalAmountIncGst?.toFixed(2) ||
                    "N/A"}
                </td> */}
                <td>
                  ₹
                  {(+subtotalPrice + +totalGst)?.toFixed(2) ||
                    item?.totalAmountIncGst?.toFixed(2) ||
                    "N/A"}
                </td>
                <td>{item?.businessName || "N/A"}</td>
                <td>
                  <span className={returnClassname(item?.status)}>
                    {item?.status || "N/A"}
                  </span>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.invoiceNumber)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default EstimateTable;
